import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Divider,
  Avatar,
  IconButton,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import tinkerersLogo from '../../utilities/dummy_assets/tinkerersLogo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';
import background from '../../utilities/dummy_assets/background.png';
import TinkerLabListAPIs from '../../utilities/api/TinkersLab/TinkerLabListAPIs';
import { toast } from 'react-toastify';
import Auth_APIs from '../../utilities/api/auth_api';
import Logos from '../../components/logos';
import GetTLFromLDAP from '../../utilities/api/user/GetTLFromLDAP';

export default function DetailedPreview() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedAdminType, setSelectedAdminType] = useState('Admin');

  // States for form validation
  const [showValidation, setShowValidation] = useState(false);
  const [errors, setErrors] = useState({});

  // States for Admin form
  const [profilePic, setProfilePic] = useState(null);
  const [position, setPosition] = useState('');
  const [labId, setLabId] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [positionId, setPositionId] = useState('');
  const [tinkerLabsList, setTinkerLabsList] = useState([]);
  // States for MBF Admin form
  const [mbfEmail, setMbfEmail] = useState('');
  const [mbfName, setMbfName] = useState('');
  const [mbfPhone, setMbfPhone] = useState('');
  const [buttonName, setButtonName] = useState('Next');
  const [tlEnable, setTLEnable] = useState(false);
  const [tl, setTl] = useState('');
  const handleTlChange = event => {
    setTl(event.target.value);
  };

  console.log(location.state);

  const dataURLtoBlob = dataurl => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  useEffect(() => {
    const fetchTinkerLabs = async () => {
      try {
        const response = await TinkerLabListAPIs.TinkerLabsListGet();
        setTinkerLabsList(response || []);
      } catch (error) {
        console.error('Failed to fetch tinker labs:', error);
        toast.error('Failed to load TL options. Please refresh the page.');
      }
    };
    fetchTinkerLabs();
  }, []);
  // Validation rules
  const validateForm = (field = null) => {
    const newErrors = { ...errors };

    if (field === 'mbfEmail' || field === null) {
      if (!mbfEmail) {
        newErrors.mbfEmail = 'Email is required';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mbfEmail)) {
        newErrors.mbfEmail = 'Please enter a valid email address';
      } else {
        delete newErrors.mbfEmail;
      }
    }

    if (field === 'mbfName' || field === null) {
      if (!mbfName.trim()) {
        newErrors.mbfName = 'Name is required';
      } else if (mbfName.trim().length < 2) {
        newErrors.mbfName = 'Name must be at least 2 characters';
      } else if (!/^[A-Za-z\s]+$/.test(mbfName.trim())) {
        newErrors.mbfName = 'Name can only contain letters and spaces';
      } else {
        delete newErrors.mbfName;
      }
    }

    if (field === 'mbfPhone' || field === null) {
      if (!mbfPhone) {
        newErrors.mbfPhone = 'Phone number is required';
      } else if (!/^[0-9]{10}$/.test(mbfPhone)) {
        newErrors.mbfPhone = 'Phone number must be 10 digits';
      } else {
        delete newErrors.mbfPhone;
      }
    }

    // if (field === 'agreed' || field === null) {
    //   if (!agreed) {
    //     newErrors.agreed = 'You must agree to the terms and conditions';
    //   } else {
    //     delete newErrors.agreed;
    //   }
    // }

    if (field === 'profilePic' || field === null) {
      if (!profilePic) {
        newErrors.profilePic = 'Please upload a profile picture';
      } else {
        delete newErrors.profilePic;
      }
    }
    if (field === 'tl' || field === null) {
      if (tlEnable && !tl.trim()) {
        newErrors.tl = 'Please select a TL';
      } else {
        delete newErrors.tl;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Detect refresh
  useEffect(() => {
    const navigationType = performance.getEntriesByType('navigation')[0].type;
    if (navigationType === 'reload') {
      setLabId('');
      setMbfEmail('');
      setMbfName('');
      setMbfPhone('');
      setTl('');
      setProfilePic(null);
    }
  }, []);

  useEffect(() => {
    console.log(location.state);
    if (location.state?.capturedImage) {
      setProfilePic(location.state.capturedImage);
    }

    if (location.state?.position) {
      setPosition(location.state.position.label);
      setPositionId(location.state.position.id);
      console.log(location.state.position.id, '---id is');
      if (
        location.state.position.id === '0' ||
        location.state.position.id === '2'
      ) {
        setButtonName('Next');
      } else {
        setButtonName('Register');
        setTLEnable(true);
      }
    }

    if (location.state?.position_id) {
      setPositionId(location.state.position_id);
    }

    // console.log(location.state.email);
    if (location.state?.email) {
      setMbfEmail(location.state.email);
    }

    if (location.state?.name) {
      setMbfName(location.state.name);
    }

    if (location.state?.phone) {
      setMbfPhone(location.state.phone);
    }

    if (location.state?.agreed) {
      setAgreed(location.state.agreed);
    }

    if (location.state?.TL) {
      setAgreed(location.state.tl);
    }
  }, [location.state]);
  const handleRegister = async () => {
    setShowValidation(true);

    // Validate all fields
    const isValid = validateForm();

    if (!isValid) {
      // Scroll to the first error
      const firstError = Object.keys(errors)[0];
      if (firstError) {
        const element = document.querySelector(`[data-error="${firstError}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      return;
    }

    const ldap_end = '@' + mbfEmail.split('@')[1];
    let tl_name;
    try {
      tl_name = await GetTLFromLDAP.fetchTL(ldap_end);

      if (!tl_name.success) {
        toast.error(tl_name.message || 'Invalid LDAP domain');
        setErrors(prev => ({ ...prev, tl: tl_name.message }));
        return;
      }
    } catch (error) {
      toast.error(
        'Your email domain is not associated with any Tinkerers Lab.'
      );
      return;
    }

    // Form is valid, proceed with registration
    const formData = {
      email: mbfEmail,
      name: mbfName,
      phone: mbfPhone,
      position: { id: positionId, label: position },
      profilePic: profilePic,
      TL: tl_name.tl_name || tl,
    };
    if (buttonName === 'Next') {
      console.log('Formdata: ', formData);
      console.log('Form submitted successfully:', formData);
      // Navigate to the next page or submit to API
      navigate('/register-submit-3', {
        state: {
          ...location.state,
          ...formData,
          isStudentIdRequired: !!tinkerLabsList?.find(
            i => i.name === formData.TL
          )?.is_student_id_reqd,
        },
      });
    } else {
      const formData = new FormData();
      const imageBlob = dataURLtoBlob(location.state.capturedImage);
      formData.append('name', mbfName);
      formData.append('email', mbfEmail);
      formData.append('phone_number', mbfPhone);
      formData.append('TL', tl);
      formData.append('profile_pic', imageBlob, 'profile_pic.jpg');

      try {
        const response = await Auth_APIs.register(formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            console.log('Registration response:', response);
            if (
              response &&
              (response.status === 200 || response.status === 201)
            ) {
              // Navigate to check status page on successful registration
              navigate('/check-status', {
                state: {
                  email: mbfEmail,
                  status: 'pending',
                },
              });
              return;
            }
          })
          .catch(error => {
            if (error.email) {
              toast.error(
                'Email ID already registered or registration in progress. Please use a different email or contact admin.'
              );
              return;
            }
            toast.error(error.message);
          });
      } catch (error) {
        // Re-throw the error to be caught by the outer try-catch
        console.error('Registration API error:', error);
        throw error;
      }
    }
  };

  const handleBackNavigation = () => {
    navigate('/register-submit-1', {
      state: {
        // ...location.state,
        // email: mbfEmail,
        // name: mbfName,
        // phone: mbfPhone,
        position: { id: positionId, label: position },
        profilePic: profilePic,
        // TL: tl
      },
    });
  };

  return (
    <Box
      sx={{
        // width: "100vw",
        minHeight: '100vh',
        overflow: 'hidden',
        display: 'flex',
        // justifyContent: "center",
        alignItems: 'center',
        backgroundImage: { sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        // padding: "1rem",
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Top right link */}
      <Box sx={{ position: 'absolute', top: 16, right: 32 }}>
        <Typography
          component="a"
          href="/student"
          sx={{ color: '#007bff', textDecoration: 'underline' }}
        >
          Go to student site
        </Typography>
      </Box>

      {/* Main Box containing toggle + form */}
      <Box
        sx={{
          maxWidth:
            selectedAdminType === 'Admin'
              ? { xs: 400, sm: '50%' }
              : { xs: 900, sm: '60%' },
          margin: 'auto',
          background: '#fff',
          marginTop: { xs: 10, sm: 'auto' },
          p: { sm: 2 },
          borderRadius: '10px',
          boxShadow: { sm: '0px 0px 20px rgba(0,0,0,0.1)' },
        }}
      >
        {/* Toggle buttons inside main box */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            border: { xs: '1px solid #E6E6E6', sm: 'none' },
            borderTopLeftRadius: { xs: '10px' },
            borderTopRightRadius: { xs: '10px' },
          }}
        >
          <Button
            onClick={() => setSelectedAdminType('Admin')}
            sx={{
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '22px',
              color: selectedAdminType === 'Admin' ? '#000' : '#ccc',
              borderBottom:
                selectedAdminType === 'Admin' ? '2px solid black' : 'none',

              borderRadius: 0,
              flex: 1,
            }}
          >
            Admin
          </Button>
          <Button
            // onClick={() => setSelectedAdminType("MBF Admin")}
            sx={{
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '22px',
              color: selectedAdminType === 'MBF Admin' ? '#000' : '#ccc',
              borderBottom:
                selectedAdminType === 'MBF Admin' ? '2px solid black' : 'none',
              flex: 1,
              borderRadius: 0,
            }}
          >
            MBF Admin
          </Button>
        </Box>
        <Divider sx={{ mb: 3 }} />

        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            {profilePic ? (
              <img
                src={profilePic}
                alt="Profile"
                style={{
                  width: '120px',
                  height: '120px',
                  objectFit: 'cover',
                  borderRadius: '5px',
                  border:
                    showValidation && !profilePic
                      ? '2px solid #d32f2f'
                      : '2px solid #ddd',
                }}
              />
            ) : (
              <Avatar
                sx={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '5px',
                  border:
                    showValidation && !profilePic
                      ? '2px solid #d32f2f'
                      : '2px solid #ddd',
                }}
              />
            )}
            <IconButton
              onClick={() => navigate('/profile-capture')}
              sx={{
                position: 'absolute',
                bottom: -5,
                right: -5,
                backgroundColor: '#fff',
                border: '2px solid #ddd',
                width: 32,
                height: 32,
                '&:hover': { backgroundColor: '#f5f5f5' },
              }}
            >
              <EditIcon sx={{ fontSize: 16, color: '#666' }} />
            </IconButton>
          </Box>
          {showValidation && !profilePic && (
            <Typography
              color="error"
              variant="caption"
              display="block"
              sx={{ mt: 1 }}
            >
              {errors.profilePic}
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 1,
            mb: 2,
          }}
        >
          <TextField
            label="Email Address"
            value={mbfEmail}
            onChange={e => {
              setMbfEmail(e.target.value);
              validateForm('mbfEmail');
            }}
            onBlur={() => validateForm('mbfEmail')}
            error={showValidation && !!errors.mbfEmail}
            helperText={showValidation && errors.mbfEmail}
            fullWidth
            required
            margin="normal"
            type="email"
            inputProps={{
              'data-error': 'mbfEmail',
              'aria-describedby': 'email-helper-text',
            }}
            FormHelperTextProps={{
              id: 'email-helper-text',
              error: showValidation && !!errors.mbfEmail,
            }}
          />
          <TextField
            label="Full Name"
            value={mbfName}
            onChange={e => {
              setMbfName(e.target.value);
              validateForm('mbfName');
            }}
            onBlur={() => validateForm('mbfName')}
            error={showValidation && !!errors.mbfName}
            helperText={showValidation && errors.mbfName}
            fullWidth
            required
            margin="normal"
            inputProps={{
              'data-error': 'mbfName',
              'aria-describedby': 'name-helper-text',
              minLength: 2,
            }}
            FormHelperTextProps={{
              id: 'name-helper-text',
              error: showValidation && !!errors.mbfName,
            }}
          />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              gap: 1,
              gridColumn: '1 / -1',
            }}
          >
            <TextField
              label="Phone Number"
              value={mbfPhone}
              onChange={e => {
                // Only allow numbers
                const re = /^[0-9\b]+$/;
                if (e.target.value === '' || re.test(e.target.value)) {
                  setMbfPhone(e.target.value);
                  validateForm('mbfPhone');
                }
              }}
              onBlur={() => validateForm('mbfPhone')}
              inputProps={{
                maxLength: 10,
                'data-error': 'mbfPhone',
                'aria-describedby': 'phone-helper-text',
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
              error={showValidation && !!errors.mbfPhone}
              helperText={
                (showValidation && errors.mbfPhone) || '10-digit number'
              }
              fullWidth
              required
              margin="normal"
              FormHelperTextProps={{
                id: 'phone-helper-text',
                error: showValidation && !!errors.mbfPhone,
              }}
            />
            <TextField
              label="Position"
              value={position}
              disabled
              fullWidth
              margin="normal"
            />
          </Box>
          {tlEnable && (
            <Box sx={{ gridColumn: '1 / -1' }}>
              <TextField
                select
                fullWidth
                label="TL"
                value={tl}
                onChange={handleTlChange}
                onBlur={() => validateForm('tl')}
                error={showValidation && !!errors.tl}
                helperText={(showValidation && errors.tl) || ' '}
                required
                sx={{
                  mb: 1,
                  textAlign: 'left',
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-error fieldset': {
                      borderColor:
                        showValidation && errors.tl
                          ? '#d32f2f'
                          : 'rgba(0, 0, 0, 0.23)',
                    },
                    '&:hover fieldset': {
                      borderColor:
                        showValidation && errors.tl
                          ? '#d32f2f'
                          : 'rgba(0, 0, 0, 0.23)',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor:
                        showValidation && errors.tl ? '#d32f2f' : '#1976d2',
                    },
                  },
                  '& .MuiFormHelperText-root': {
                    color:
                      showValidation && errors.tl
                        ? '#d32f2f'
                        : 'rgba(0, 0, 0, 0.6)',
                  },
                }}
                inputProps={{
                  'data-error': 'tl',
                  'aria-describedby': 'tl-helper',
                  'aria-invalid': !!(showValidation && errors.tl),
                }}
                FormHelperTextProps={{
                  sx: {
                    marginLeft: 0,
                    marginTop: 0.5,
                    fontSize: '0.75rem',
                    lineHeight: 1.66,
                    letterSpacing: '0.03333em',
                  },
                }}
              >
                <MenuItem value="">Select TL</MenuItem>
                {tinkerLabsList
                  .filter(lab => lab.name !== 'MBF Admin')
                  .map(lab => (
                    <MenuItem key={lab.name} value={lab.name}>
                      {lab.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Box>
          )}
        </Box>

        {/* <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 2,
            mt: 2,
            border: showValidation && !agreed ? '1px solid #d32f2f' : '1px solid transparent',
            borderRadius: '4px',
            p: showValidation && !agreed ? '8px' : '0',
            backgroundColor: showValidation && !agreed ? '#fff5f5' : 'transparent'
          }}
          data-error="agreed"
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={agreed}
                onChange={(e) => {
                  setAgreed(e.target.checked);
                  validateForm('agreed');
                }}
                onBlur={() => validateForm('agreed')}
                sx={{
                  color: showValidation && !agreed ? "#d32f2f" : undefined,
                  "&.Mui-checked": { color: "#007bff" },
                  padding: '8px',
                  marginRight: '4px'
                }}
                inputProps={{
                  'data-error': 'agreed',
                  'aria-describedby': 'terms-helper-text'
                }}
              />
            }
            label={
              <Typography
                sx={{
                  color: showValidation && !agreed ? "#d32f2f" : "inherit",
                  fontSize: "14px",
                  margin: 0,
                  lineHeight: '1.5',
                  paddingLeft: '4px'
                }}
                id="terms-helper-text"
              >
                By using the MBF MIS, you consent to the processing of your information.*
              </Typography>
            }
            sx={{
              margin: 0,
              '& .MuiFormControlLabel-label': {
                margin: 0
              }
            }}
          />
        </Box>
        {showValidation && !agreed && (
          <Typography color="error" variant="caption" display="block" sx={{ mt: -1, mb: 1 }}>
            {errors.agreed}
          </Typography>
        )} */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 2,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate('/login')}
            sx={{ flex: 1 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleRegister}
            sx={{ backgroundColor: '#007bff', flex: 1 }}
          >
            {buttonName}
          </Button>
        </Box>
        <Box
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              color: '#007BFF',
              fontWeight: 500,
              fontSize: '16px',
              cursor: 'pointer',
              px: '5px',
            }}
            onClick={handleBackNavigation}
          >
            &lt;
            <Typography
              component="span"
              sx={{
                display: { xs: 'none', sm: 'inline' },
              }}
            >
              back
            </Typography>
          </Typography>
          <Box>
            Already Have an Account?
            <Button variant="text" onClick={() => navigate('/login')}>
              Login
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Footer Logos */}
      <Logos />
    </Box>
  );
}
